import { createSelector } from '@ngrx/store';
import { tenantsAdapter, initialState, TenantsState } from './tenants.feature';
import type { TenantDto } from './models/tenant.model';

type RootState = { tenants?: TenantsState } | undefined;
const selectTenantsState = (state: RootState): TenantsState => state?.tenants ?? initialState;
export const selectQuery = createSelector(selectTenantsState, (s) => s.query);
export const selectFilters = createSelector(selectTenantsState, (s) => s.filters);
export const selectLoading = createSelector(selectTenantsState, (s) => s.loading);
export const selectSaving = createSelector(selectTenantsState, (s) => s.saving);
export const selectTotalElements = createSelector(selectTenantsState, (s) => s.totalElements);
export const selectCurrentPage = createSelector(selectTenantsState, (s) => s.currentPage);
export const selectPageSize = createSelector(selectTenantsState, (s) => s.pageSize);

const { selectAll: selectAllTenants } = tenantsAdapter.getSelectors(selectTenantsState);
export { selectAllTenants };

// Search is applied server-side; filters are also sent to the server, and re-applied here so they
// still narrow the loaded page if the endpoint ignores them.
export const selectFilteredTenants = createSelector(
  selectAllTenants,
  selectFilters,
  (all: readonly TenantDto[], filters: Record<string, unknown[]>): readonly TenantDto[] => {
    let result = all;
    for (const [key, values] of Object.entries(filters)) {
      if (!values.length) continue;
      result = result.filter((t) => {
        const rowVal = (t as unknown as Record<string, unknown>)[key];
        return values.some((v) => (Array.isArray(rowVal) ? rowVal.includes(v) : rowVal === v));
      });
    }
    return result;
  },
);

export const selectTenantById = (tenantId: string) =>
  createSelector(selectAllTenants, (all: readonly TenantDto[]) => {
    return all.find((t) => t.tenantUuid === tenantId) ?? null;
  });
